
import { Button } from '@elparking/components'
import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'

const LinkToWebButton = styled(Button)`
display: flex;
text-decoration: none;
flex-wrap: wrap;
align-content: center;
justify-content: center;
`
const LinkButton = ({children, ...restProps}) => (
    <LinkToWebButton as='a' fontSize='xSmall' fontColor='white' fontWeight='bold' borderRadius='4px' backgroundColor='main' textDecoration='none' decoration='none' padding='6px' mt='1em' {...restProps}>
        {children}
    </LinkToWebButton>
)
LinkButton.propTypes = {
    children: PropTypes.node,
}
export default LinkButton
